'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  isBounded: _propTypes2.default.bool
};

var defaultProps = {
  isBounded: false
};

var textStyle = function textStyle(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.tag,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;


  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
};

var isBounded = function isBounded(_ref2) {
  var isBounded = _ref2.isBounded;
  return isBounded && '\n  white-space: nowrap;\n';
};

var TextStyled = exports.TextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'TextStyled'
})(['color:currentColor;', ' ', ''], textStyle, isBounded);

TextStyled.propTypes = propTypes;
TextStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tag/dist/styles/TextStyled.js
// module id = 833
// module chunks = 0